import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const LinkNext = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='LinkNext' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,12 L22,12 M13,3 L22,12 L13,21' />
  </StyledIcon>
);
